export const COMPACT_VERTICAL_SPACE = 20;
export const LINE_WIDTH = 1.5;
export const TRIAL_SIZE_PERCENTAGE = '100%';
export const GRADIENT_SUFFIXES = ['01', '02', '03', '04'];
export const DURATION = 2;
